import { SearchState } from '../types/searchParams.types';
import {
	FacetSlugBGOV,
	FacetSlugOP,
	getProjectFacets,
} from '../config/searchFacets.config';
import { searchFilter, searchPage, searchTerm } from './getSearchURL';

export const getSearchState = (searchParams: URLSearchParams): SearchState => {
	const facets = getProjectFacets();

	const defaultState: SearchState = {
		term: '',
		facetSlug: facets[0].slug,
		page: 1,
	};

	const filter = searchParams.get(searchFilter);

	const isFilterType = (
		filter: string | null,
	): filter is FacetSlugBGOV | FacetSlugOP => {
		return filter != null && facets.some(({ slug }) => slug === filter);
	};

	const state: SearchState = {
		term: searchParams.get(searchTerm) ?? '',
		facetSlug: isFilterType(filter) ? filter : defaultState.facetSlug,
		page: Number(searchParams.get(searchPage) ?? defaultState.page),
	};

	return state;
};
